"use client";

import { c as _c } from "react/compiler-runtime";
import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Columns3Icon, GripVerticalIcon, ListCollapseIcon, Trash2Icon } from "lucide-react";
import { nanoid } from "nanoid";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
export const ExpandableForm = t0 => {
  const $ = _c(48);
  const {
    data
  } = t0;
  const context = useStoreBuilderContext();
  let t1;
  if ($[0] !== data?.expandable) {
    t1 = data?.expandable ?? [];
    $[0] = data?.expandable;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [items, setItems] = useState(t1);
  let t2;
  if ($[2] !== data?.expandable) {
    t2 = () => {
      setItems(data?.expandable ?? []);
    };
    $[2] = data?.expandable;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = data?.expandable;
  let t4;
  if ($[4] !== t3) {
    t4 = [t3];
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useEffect(t2, t4);
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      coordinateGetter: sortableKeyboardCoordinates
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, t5));
  let t6;
  if ($[7] !== context || $[8] !== items) {
    t6 = event => {
      const {
        active,
        over
      } = event;
      if (!over) {
        return;
      }
      if (active.id !== over.id) {
        const oldIndex = items.findIndex(item => item.id === active.id);
        const newIndex = items.findIndex(item_0 => item_0.id === over.id);
        const udpatedItems = arrayMove(items, oldIndex, newIndex);
        setItems(udpatedItems);
        context.saveSelectedPageSectionField({
          fieldPath: "expandable",
          value: udpatedItems
        });
      }
    };
    $[7] = context;
    $[8] = items;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleDragEnd = t6;
  let t7;
  if ($[10] !== context || $[11] !== items) {
    t7 = (id, newItem) => {
      const udpatedItems_0 = items.map(item_1 => item_1.id === id ? newItem : item_1);
      setItems(udpatedItems_0);
      context.saveSelectedPageSectionField({
        fieldPath: "expandable",
        value: udpatedItems_0
      });
    };
    $[10] = context;
    $[11] = items;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleItemUpdate = t7;
  let t8;
  if ($[13] !== context || $[14] !== items) {
    t8 = id_0 => {
      const udpatedItems_1 = items.filter(item_2 => item_2.id !== id_0);
      setItems(udpatedItems_1);
      context.saveSelectedPageSectionField({
        fieldPath: "expandable",
        value: udpatedItems_1
      });
    };
    $[13] = context;
    $[14] = items;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const handleDeleteItem = t8;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      const newItem_0 = {
        id: nanoid(),
        title: "",
        content: undefined
      };
      setItems(items_0 => [...items_0, newItem_0]);
    };
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const addNewItem = t9;
  const t10 = data?.layout ?? "accordion";
  let t11;
  if ($[17] !== context) {
    t11 = value => {
      context.saveSelectedPageSectionField({
        fieldPath: "layout",
        value
      });
    };
    $[17] = context;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <TabsTrigger value="accordion"><ListCollapseIcon className="w-4 h-4 mr-1" />Accordion</TabsTrigger>;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <TabsList className="grid w-full grid-cols-2">{t12}<TabsTrigger value="tabs"><Columns3Icon className="w-4 h-4 mr-1" />Tabs</TabsTrigger></TabsList>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t10 || $[22] !== t11) {
    t14 = <Tabs defaultValue={t10} className="w-full" onValueChange={t11}>{t13}</Tabs>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== items) {
    t15 = items.map(_temp);
    $[24] = items;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== handleDeleteItem || $[27] !== handleItemUpdate || $[28] !== items) {
    let t17;
    if ($[30] !== handleDeleteItem || $[31] !== handleItemUpdate) {
      t17 = item_4 => <SortableItem key={item_4.id} item={item_4} onDeleteItem={handleDeleteItem} onItemUpdate={handleItemUpdate} />;
      $[30] = handleDeleteItem;
      $[31] = handleItemUpdate;
      $[32] = t17;
    } else {
      t17 = $[32];
    }
    t16 = items.map(t17);
    $[26] = handleDeleteItem;
    $[27] = handleItemUpdate;
    $[28] = items;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[33] !== t16) {
    t17 = <div className="space-y-1">{t16}</div>;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t17) {
    t18 = <SortableContext items={t15} strategy={verticalListSortingStrategy}>{t17}</SortableContext>;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== handleDragEnd || $[39] !== sensors || $[40] !== t18) {
    t19 = <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>{t18}</DndContext>;
    $[38] = handleDragEnd;
    $[39] = sensors;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Button type="button" className="w-full rounded-full" onClick={addNewItem}>Add Menu Item</Button>;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t19) {
    t21 = <div className="space-y-2">{t19}{t20}</div>;
    $[43] = t19;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t14 || $[46] !== t21) {
    t22 = <div>{t14}{t21}</div>;
    $[45] = t14;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  return t22;
};
function SortableItem(t0) {
  const $ = _c(33);
  const {
    item,
    onDeleteItem,
    onItemUpdate
  } = t0;
  let t1;
  if ($[0] !== item.id) {
    t1 = {
      id: item.id
    };
    $[0] = item.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable(t1);
  let t2;
  if ($[2] !== transform) {
    t2 = CSS.Translate.toString(transform);
    $[2] = transform;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isDragging ? 1 : 0;
  const t4 = isDragging ? 0.8 : 1;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== transition) {
    t5 = {
      transform: t2,
      transition,
      zIndex: t3,
      opacity: t4,
      position: "relative"
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = transition;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const style = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <GripVerticalIcon className="h-5 w-5 text-gray-400" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== attributes || $[11] !== listeners) {
    t7 = <div className="cursor-grab active:cursor-grabbing p-1 hover:bg-gray-100 rounded touch-none" {...attributes} {...listeners}>{t6}</div>;
    $[10] = attributes;
    $[11] = listeners;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = item.title ?? "";
  let t9;
  if ($[13] !== item || $[14] !== onItemUpdate) {
    t9 = e => {
      const value = e.target.value;
      onItemUpdate(item.id, {
        ...item,
        title: value
      });
    };
    $[13] = item;
    $[14] = onItemUpdate;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <div className="flex-1 flex flex-row items-center gap-2"><Input value={t8} onChange={t9} className="h-8" placeholder="Title" /></div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== item.id || $[20] !== onDeleteItem) {
    t11 = () => onDeleteItem(item.id);
    $[19] = item.id;
    $[20] = onDeleteItem;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Trash2Icon className="h-4 w-4 text-destructive" />;
    t13 = <span className="sr-only">Delete</span>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t12 = $[22];
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11) {
    t14 = <Button size="sm" variant="ghost" onClick={t11}>{t12}{t13}</Button>;
    $[24] = t11;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== item.id || $[27] !== setNodeRef || $[28] !== style || $[29] !== t10 || $[30] !== t14 || $[31] !== t7) {
    t15 = <div ref={setNodeRef} style={style} className="p-2 flex items-center gap-1 bg-white" data-row-id={item.id}>{t7}{t10}{t14}</div>;
    $[26] = item.id;
    $[27] = setNodeRef;
    $[28] = style;
    $[29] = t10;
    $[30] = t14;
    $[31] = t7;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}
function _temp(item_3) {
  return item_3.id;
}